import fetchDependencies from "./helpers/fetch-dependencies"
import { currentUtmParams, trackCheckoutPurchase } from "./services/analytics"

export async function init(options = {}) {
  const { Vue, VueI18n, data } = await fetchDependencies()
  const { default: signup } = await import(/* webpackChunkName: 'sign-up' */ "./signup")
  signup(Vue, VueI18n, data, options)
}

const { FCGON } = window

export function showSignup(options = {}) {
  if (FCGON.is_app) {
    const { callNativeApp } = window
    if (callNativeApp) {
      callNativeApp("subscribe")
      return
    }
  }
  init(options)
}

window.showSignup = showSignup

function checkoutStatus() {
  const params = new URLSearchParams(window.location.search) // eslint-disable-line compat/compat
  return params.get("checkout")
}

function checkoutSessionId() {
  const params = new URLSearchParams(window.location.search) // eslint-disable-line compat/compat
  return params.get("session_id")
}

function trackCheckoutSuccessPurchase() {
  if (checkoutStatus() !== "success") return

  const sessionId = checkoutSessionId()
  const params = currentUtmParams()
  trackCheckoutPurchase(sessionId, params)
}

function checkoutStepOptions() {
  const status = checkoutStatus()
  if (status === "success") {
    return { initialStep: "the-finish" }
  }
  if (status === "cancelled") {
    return { initialStep: FCGON && FCGON.logged_in ? "the-plan-selection" : "the-promo-signup" }
  }

  return {}
}

function hasCheckoutResult() {
  const status = checkoutStatus()
  return status === "success" || status === "cancelled"
}

function cleanCheckoutResultFromUrl() {
  if (!window.history || !window.history.replaceState) return

  const url = new URL(window.location.href) // eslint-disable-line compat/compat
  url.searchParams.delete("checkout")
  url.searchParams.delete("session_id")
  window.history.replaceState(window.history.state, document.title, url.toString())
}

function mountSubscribe(node) {
  while (node.firstChild) {
    node.removeChild(node.firstChild)
  }
  const mountNode = document.createElement("div")
  node.appendChild(mountNode)
  init({
    el: mountNode,
    ...checkoutStepOptions(),
    variant: "page",
  })
}

export default async function setListeners() {
  const subscribeNodes = Array.from(document.querySelectorAll(".js-subscribe"))
  subscribeNodes.forEach((node) => {
    mountSubscribe(node)
  })
  if (subscribeNodes.length > 0 && hasCheckoutResult()) {
    trackCheckoutSuccessPurchase()
    cleanCheckoutResultFromUrl()
  }

  const nodes = Array.from(document.querySelectorAll(".js-sign-up, .js-sign-up-no-free"))
  nodes.forEach((node) => {
    node.addEventListener("click", (event) => {
      event.preventDefault()
      showSignup()
    })
  })
  // Automatic startup on the dedicated sign up page
  if (subscribeNodes.length === 0 && hasCheckoutResult()) {
    showSignup(checkoutStepOptions())
    trackCheckoutSuccessPurchase()
    cleanCheckoutResultFromUrl()
  } else if (FCGON && FCGON.sign_up_immediately) {
    init()
  }
}
